import { updateSalary } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdateSalary = () => {
    const queryClient = useQueryClient();
    return useMutation(updateSalary, {
        onSuccess: () => {
            toast.success("Updated sucesfully");
            queryClient.invalidateQueries('salaries');
        },
        onError: (error: any) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
                return;
            }
            if (error.response?.data?.error) {
                toast.error(error.response.data.error);
                return;
            }
            toast.error("Something went wrong! Please try again later.");
        },
    })
}